// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__1GcS9","checkmark":"Checkbox_checkmark__1GXSk","disabled":"Checkbox_disabled__2TfpO"};